import React, {useEffect, useState} from "react";
import Img from "../../components/Images";
import BoxProduct from "./Boxproduct";
import {getCategories} from "../../service/myProductService";

const Productcategory=()=>{
    const img = [
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/1-sua-cho-be-26082426082024090723.jpg',
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/2-bim-ta-26082426082024420985.jpg',	
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/3-binh-sua-26082426082024371058.jpg',	
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/4-an-dam-dinh-duong-26082426082024271193.jpg',		
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/5-vitamin-suc-khoe-26082426082024591104.jpg',
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/6-do-dung-me-va-be-26082426082024331266.jpg',
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/7-do-so-sinh-26082426082024041371.jpg',
        'https://mediacdn1.bibomart.net/images/2024/8/26/0/origin/8-thoi-trang-phu-kien-26082426082024031411.jpg',		
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/9-xe-cho-be-26082426082024311436.jpg',
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/10-do-choi-hoc-tap-26082426082024581497.jpg',		
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/11-me-bau-sau-sinh-26082426082024341536.jpg',	
        'https://bibomartcdn.multicdn.top/images/2024/8/26/0/origin/12-cham-soc-gia-dinh-26082426082024101698.jpg',
    ];
    const link = [
        '/sua-bot-cac-loai.html',
        '/bim-ta-va-ve-sinh.html',
        '/binh-sua-va-phu-kien.html',
        '/an-dam-dinh-duong.html',
        '/vitamin-va-suc-khoe.html',
        '/do-dung-me-va-be.html',
        '/do-so-sinh.html',
        '/thoi-trang-va-phu-kien.html',
        '/xe-cho-be.html',
        '/be-choi-va-hoc.html',
        '/me-bau-va-sau-sinh.html',
        '/cham-soc-gia-dinh.html'
    ];
    const [catalog, setCatalog] = useState([]);

      const getDataCategories= async()=>{
        await getCategories().then((response)=>{
            if(+response.status === 200){
                setCatalog(response.message);
                window.localStorage.setItem('cateNode', true);
            }
        });
      }

    useEffect(()=>{
        getDataCategories();
    },[]);
    
    if(catalog.length > 0){
    return(
        catalog.map((item, index)=>{
            return <div key={index} className="product__list">
            <div className="container m-auto p-0">
                <div className="row row--maint m-0">
                    <div className="col-12 px-0">
                        <div className="maint__title">
                            <div className="row m-0">
                                <div className="maint__title--middle col-11 p-0">
                                <h2 className="float-start fw-bold pe-5">{item.name}</h2>
                                    <div className="milk__baby--title--middle d-flex flex-row">
                                        {
                                        item.child.length > 0 ? (
                                           item.child?.slice(0,4).map((Node,k)=>{
                                               return <div key={k} className="me-5"><a href={"/"+Node.url_key+".html"} className=""><span>{Node.name}</span></a></div>
                                            })
                                        ):(null)
                                        }
                                    </div>
                                </div>
                                <div className="maint__title--right col-1 px-0">
                                    <div className="float-end position-relative"><a href={"/"+item.url_key+".html"}>Xem tất cả</a> <i className="fa-solid fa-chevron-right"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 p-0">
                        <div className="mant__item">
                            <div className="row m-0 h-auto w-100 d-flex ">
                                <div className="col-3 h-auto px-2 ps-0" style={{width:320}}>
                                    <div className="bg-danger banner-home">
                                        {/* <Img imgTitle={item?.name} url={item.image_bg} className="h-100" style=""/> */}
                                       <a href={'/'+item.url_key+'.html'}> <Img imgTitle={item?.name} url={item.image_bg} className="h-100" style=""/></a>
                                    </div>
                                </div>
                                <BoxProduct key={index} uri={item.url_key}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
        })
    )
    }else{
        return null;
    }
}

export default Productcategory;